var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "report-menu" }, [
    _c(
      "div",
      {
        staticClass: "box yes-hover",
        class: { active: _vm.currentTab === _vm.ReportTabs.OVERALL },
        on: {
          click: function ($event) {
            return _vm.updateQueryParams("report", _vm.ReportTabs.OVERALL)
          },
        },
      },
      [
        _c("p", { staticClass: "label" }, [
          _c("i", { staticClass: "material-icons" }, [_vm._v("trending_up")]),
          _vm._v(
            "\n\n            " + _vm._s(_vm.$t("report.overall")) + "\n        "
          ),
        ]),
        _vm._v(" "),
        _c(
          "p",
          { staticClass: "value" },
          [
            _vm.loading
              ? _c("BarSpinner", {
                  attrs: { className: "spinner", radius: 15 },
                })
              : _vm._e(),
          ],
          1
        ),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "box yes-hover",
        class: { active: _vm.currentTab === _vm.ReportTabs.CHAT_DISTRIBUTIONS },
        on: {
          click: function ($event) {
            return _vm.updateQueryParams(
              "report",
              _vm.ReportTabs.CHAT_DISTRIBUTIONS
            )
          },
        },
      },
      [
        _c("p", { staticClass: "label" }, [
          _c("i", { staticClass: "material-icons" }, [_vm._v("donut_small")]),
          _vm._v(_vm._s(_vm.$t("report.chatDistributions"))),
        ]),
        _vm._v(" "),
        _c(
          "p",
          { staticClass: "value" },
          [
            _vm.loading
              ? _c("BarSpinner", {
                  attrs: { className: "spinner", radius: 15 },
                })
              : _vm._e(),
          ],
          1
        ),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "box yes-hover",
        class: {
          active: _vm.currentTab === _vm.ReportTabs.CONTACT_DISTRIBUTIONS,
        },
        on: {
          click: function ($event) {
            return _vm.updateQueryParams(
              "report",
              _vm.ReportTabs.CONTACT_DISTRIBUTIONS
            )
          },
        },
      },
      [
        _c("p", { staticClass: "label" }, [
          _c("i", { staticClass: "material-icons" }, [_vm._v("donut_small")]),
          _vm._v(_vm._s(_vm.$t("report.contactDistributions"))),
        ]),
        _vm._v(" "),
        _c(
          "p",
          { staticClass: "value" },
          [
            _vm.loading
              ? _c("BarSpinner", {
                  attrs: { className: "spinner", radius: 15 },
                })
              : _vm._e(),
          ],
          1
        ),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "box yes-hover",
        class: { active: _vm.currentTab === _vm.ReportTabs.AGENT_PERFORMANCE },
        on: {
          click: function ($event) {
            return _vm.updateQueryParams(
              "report",
              _vm.ReportTabs.AGENT_PERFORMANCE
            )
          },
        },
      },
      [
        _c("p", { staticClass: "label" }, [
          _c("i", { staticClass: "material-icons" }, [_vm._v("speed")]),
          _vm._v(_vm._s(_vm.$t("report.agentPerformance"))),
        ]),
        _vm._v(" "),
        _c(
          "p",
          { staticClass: "value" },
          [
            _vm.loading
              ? _c("BarSpinner", {
                  attrs: { className: "spinner", radius: 15 },
                })
              : _vm._e(),
          ],
          1
        ),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "box yes-hover",
        class: { active: _vm.currentTab === _vm.ReportTabs.AGENT_ACTIVITIES },
        on: {
          click: function ($event) {
            return _vm.updateQueryParams(
              "report",
              _vm.ReportTabs.AGENT_ACTIVITIES
            )
          },
        },
      },
      [
        _c("p", { staticClass: "label" }, [
          _c("i", { staticClass: "material-icons" }, [_vm._v("wifi")]),
          _vm._v(_vm._s(_vm.$t("report.dailyAgentActivity"))),
        ]),
        _vm._v(" "),
        _c(
          "p",
          { staticClass: "value" },
          [
            _vm.loading
              ? _c("BarSpinner", {
                  attrs: { className: "spinner", radius: 15 },
                })
              : _vm._e(),
          ],
          1
        ),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "box yes-hover",
        class: { active: _vm.currentTab === _vm.ReportTabs.AGENT_WORK_TIME },
        on: {
          click: function ($event) {
            return _vm.updateQueryParams(
              "report",
              _vm.ReportTabs.AGENT_WORK_TIME
            )
          },
        },
      },
      [
        _c("p", { staticClass: "label" }, [
          _c("i", { staticClass: "material-icons" }, [
            _vm._v("history_toggle_off"),
          ]),
          _vm._v(_vm._s(_vm.$t("report.teamBreakAnalysis"))),
        ]),
        _vm._v(" "),
        _c(
          "p",
          { staticClass: "value" },
          [
            _vm.loading
              ? _c("BarSpinner", {
                  attrs: { className: "spinner", radius: 15 },
                })
              : _vm._e(),
          ],
          1
        ),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "box yes-hover",
        class: {
          active: _vm.currentTab === _vm.ReportTabs.CUSTOMER_SATISFACTION,
        },
        on: {
          click: function ($event) {
            return _vm.updateQueryParams(
              "report",
              _vm.ReportTabs.CUSTOMER_SATISFACTION
            )
          },
        },
      },
      [
        _c("p", { staticClass: "label" }, [
          _c("i", { staticClass: "material-icons" }, [
            _vm._v("sentiment_very_satisfied"),
          ]),
          _vm._v(_vm._s(_vm.$t("report.customerSatisfaction")) + "\n        "),
        ]),
        _vm._v(" "),
        _c(
          "p",
          { staticClass: "value" },
          [
            _vm.loading
              ? _c("BarSpinner", {
                  attrs: { className: "spinner", radius: 15 },
                })
              : _vm._e(),
          ],
          1
        ),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "box yes-hover",
        class: { active: _vm.currentTab === _vm.ReportTabs.WEBSITE_ANALYSIS },
        on: {
          click: function ($event) {
            return _vm.updateQueryParams(
              "report",
              _vm.ReportTabs.WEBSITE_ANALYSIS
            )
          },
        },
      },
      [
        _c("p", { staticClass: "label" }, [
          _c("i", { staticClass: "material-icons" }, [_vm._v("query_stats")]),
          _vm._v(_vm._s(_vm.$t("report.websiteAnalysis"))),
        ]),
        _vm._v(" "),
        _c(
          "p",
          { staticClass: "value" },
          [
            _vm.loading
              ? _c("BarSpinner", {
                  attrs: { className: "spinner", radius: 15 },
                })
              : _vm._e(),
          ],
          1
        ),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "box yes-hover",
        class: { active: _vm.currentTab === _vm.ReportTabs.CHANNEL_BREAKDOWN },
        on: {
          click: function ($event) {
            return _vm.updateQueryParams(
              "report",
              _vm.ReportTabs.CHANNEL_BREAKDOWN
            )
          },
        },
      },
      [
        _c("p", { staticClass: "label" }, [
          _c("i", { staticClass: "material-icons" }, [_vm._v("hub")]),
          _vm._v(_vm._s(_vm.$t("report.channelBreakdown"))),
        ]),
        _vm._v(" "),
        _c(
          "p",
          { staticClass: "value" },
          [
            _vm.loading
              ? _c("BarSpinner", {
                  attrs: { className: "spinner", radius: 15 },
                })
              : _vm._e(),
          ],
          1
        ),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "box yes-hover",
        class: {
          active: _vm.currentTab === _vm.ReportTabs.WHATSAPP_BUSINESS_API,
        },
        on: {
          click: function ($event) {
            return _vm.updateQueryParams(
              "report",
              _vm.ReportTabs.WHATSAPP_BUSINESS_API
            )
          },
        },
      },
      [
        _c(
          "p",
          { staticClass: "label" },
          [
            _c("WhatsappBusinessIcon", {
              staticStyle: { width: "30px", height: "30px" },
              attrs: { color: "#58ca64" },
            }),
            _vm._v("\n            Whatsapp Business API\n        "),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "p",
          { staticClass: "value" },
          [
            _vm.loading
              ? _c("BarSpinner", {
                  attrs: { className: "spinner", radius: 15 },
                })
              : _vm._e(),
          ],
          1
        ),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "box yes-hover",
        class: { active: _vm.currentTab === _vm.ReportTabs.Calendar },
        on: {
          click: function ($event) {
            return _vm.updateQueryParams("report", _vm.ReportTabs.Calendar)
          },
        },
      },
      [
        _c("p", { staticClass: "label" }, [
          _c("i", { staticClass: "material-icons" }, [
            _vm._v("calendar_month"),
          ]),
          _vm._v(
            "\n            " + _vm._s(_vm.$t("message.calendar")) + "\n        "
          ),
        ]),
        _vm._v(" "),
        _c(
          "p",
          { staticClass: "value" },
          [
            _vm.loading
              ? _c("BarSpinner", {
                  attrs: { className: "spinner", radius: 15 },
                })
              : _vm._e(),
          ],
          1
        ),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "box yes-hover",
        class: { active: _vm.currentTab === _vm.ReportTabs.Mail },
        on: {
          click: function ($event) {
            return _vm.updateQueryParams("report", _vm.ReportTabs.Mail)
          },
        },
      },
      [
        _c("p", { staticClass: "label" }, [
          _c("i", { staticClass: "material-icons" }, [
            _vm._v("event_available"),
          ]),
          _vm._v(
            "\n            " + _vm._s(_vm.$t("message.mails")) + "\n        "
          ),
        ]),
        _vm._v(" "),
        _c(
          "p",
          { staticClass: "value" },
          [
            _vm.loading
              ? _c("BarSpinner", {
                  attrs: { className: "spinner", radius: 15 },
                })
              : _vm._e(),
          ],
          1
        ),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "box yes-hover",
        class: { active: _vm.currentTab === _vm.ReportTabs.Ticket },
        on: {
          click: function ($event) {
            return _vm.updateQueryParams("report", _vm.ReportTabs.Ticket)
          },
        },
      },
      [
        _c("p", { staticClass: "label" }, [
          _c("i", { staticClass: "material-icons" }, [
            _vm._v("confirmation_number"),
          ]),
          _vm._v(
            "\n            " + _vm._s(_vm.$t("message.ticket")) + "\n        "
          ),
        ]),
        _vm._v(" "),
        _c(
          "p",
          { staticClass: "value" },
          [
            _vm.loading
              ? _c("BarSpinner", {
                  attrs: { className: "spinner", radius: 15 },
                })
              : _vm._e(),
          ],
          1
        ),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "box yes-hover mb-5",
        class: { active: _vm.currentTab === _vm.ReportTabs.TASK },
        on: {
          click: function ($event) {
            return _vm.updateQueryParams("report", _vm.ReportTabs.TASK)
          },
        },
      },
      [
        _c("p", { staticClass: "label" }, [
          _c("i", { staticClass: "md-icon" }, [
            _vm._v("picture_in_picture_alt"),
          ]),
          _vm._v(
            "\n            " + _vm._s(_vm.$t("task.workflow")) + "\n        "
          ),
        ]),
        _vm._v(" "),
        _c(
          "p",
          { staticClass: "value" },
          [
            _vm.loading
              ? _c("BarSpinner", {
                  attrs: { className: "spinner", radius: 15 },
                })
              : _vm._e(),
          ],
          1
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }